import React from "react";

type Props = {
  size: number,
  color: string
};

const Draggable = ({ size = 20, color = "#2A2A2A", ...rest }: Props) => (
  <svg width={size} height={size} fill="none" role="img" aria-hidden {...rest}>
    <line y1="0.5" x2={size} y2="0.5" stroke={color} />
    <line y1="5.5" x2={size} y2="5.5" stroke={color} />
    <line y1="10.5" x2={size} y2="10.5" stroke={color} />
  </svg>
);

export default Draggable;
